// First-touch acquisition capture — Task 8.
//
// Captures acquisition EVIDENCE present in the URL / referrer on the visitor's
// first landing and persists it (first-touch only) so a later enquiry can be
// attributed to how the visitor arrived. This records CAPTURED EVIDENCE only —
// it never guesses. When no evidence is present the source stays "unknown".
//
// PRIVACY: gclid + utm params + the referrer HOSTNAME (not the full URL) are
// stored locally and sent with the enquiry. The raw gclid is retained server-
// side for Google Ads offline matching but is NEVER included in the PII-free
// reporting CSV. No participant/health data is ever captured here.

const KEY = "__fca_attribution_v1";

export function captureAttribution() {
  if (typeof window === "undefined") return;
  try {
    // First-touch: never overwrite an earlier capture.
    if (window.localStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search || "");

    let referrer_domain = "";
    try {
      if (document.referrer) {
        const h = new URL(document.referrer).hostname || "";
        // Ignore internal (same-host) navigation — not an acquisition source.
        if (h && h !== window.location.hostname) referrer_domain = h;
      }
    } catch (_) { /* malformed referrer — ignore */ }

    const data = {
      gclid: p.get("gclid") || "",
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
      utm_term: p.get("utm_term") || "",
      utm_content: p.get("utm_content") || "",
      referrer_domain,
      landing_path: window.location.pathname || "",
      captured_at: new Date().toISOString(),
    };

    // Only persist if we actually captured something OR to pin first-touch as
    // "direct/unknown" so a later page (with a referrer param) can't overwrite it.
    window.localStorage.setItem(KEY, JSON.stringify(data));
  } catch (_) { /* storage disabled / private mode — proceed without attribution */ }
}

export function getAttribution() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}
